import { FormControlLabel } from '@material-ui/core';
import { Checkbox } from '@material-ui/core';
import { startsWith } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectField from '../../../components/forms/SelectField';
import { MODELS } from '../../../constants/admin/settings';
import { ALL_EVENTS_PERMISSIONS_OPTION } from '../../../constants/authentication/permissions';
import * as selectors from '../../../selectors/admin/models/permissions';
import { canChangePerformanceAccess, currentUserSelector } from '../../../selectors/authentication';

class PermissionInputs extends Component {
    componentDidUpdate() {
        this._forceContext();
    }

    _forceContext() {
        const { context, data } = this.props;
        if (context && startsWith(data.function, MODELS.ORGANIZATION) && data.group !== context) {
            this.props.onInput(context, 'group', true);
        }
        if (this.props.showOrganizations && context && data.orgId !== context) {
            this.props.onInput(context, 'orgId', true);
        }
        if (this.props.isArtistUser && !data.accessToClearanceContracts) {
            this._inputCheckbox(true, 'accessToClearanceContracts');
        }
        if (this.props.isOrganizationUser && !data.accessToClearanceContracts) {
            this._inputCheckbox(true, 'accessToClearanceContracts');
        }
    }

    _inputFunction = (value, name) => {
        ['group', 'name', 'orgId', 'eventId', 'accessToPerformanceContracts'].forEach(field =>
            this.props.onInput('', field)
        );
        this.props.onInput(value, name);
    };

    _inputCheckbox = (value, name) => {
        this.props.onInput(value, name);
    };

    _inputEventReset = (value, name) => {
        this.props.onInput(false, 'accessToPerformanceContracts');
        this.props.onInput('', 'eventId');
        this.props.onInput(value, name);
        if (!ALL_EVENTS_PERMISSIONS_OPTION.notFor.includes(this.props.data.name)) {
            this.props.onInput(ALL_EVENTS_PERMISSIONS_OPTION.value, 'eventId');
        }
    };

    _rolesSelect = (value, name) => {
        this.props.onInput(value, name);
        if (!ALL_EVENTS_PERMISSIONS_OPTION.notFor.includes(value)) {
            this.props.onInput(ALL_EVENTS_PERMISSIONS_OPTION.value, 'eventId');
        }
    };

    _canChangePerformanceAccess = () => {
        return canChangePerformanceAccess(
            this.props.user,
            this.props.data.function === 'artist'
                ? this.props.data.orgId
                : this.props.data.group || this.props.data.orgId
        );
    };
    render() {
        return (
            <React.Fragment>
                <div className="ckp-admin-grid-row">
                    <div className="ckp-admin-grid-column">
                        <SelectField
                            items={this.props.functionsForSelect}
                            label="Type *"
                            onChange={this._inputFunction}
                            name="function"
                            value={this.props.data.function}
                        />
                    </div>
                    <div className="ckp-admin-grid-column">
                        <SelectField
                            disabled={
                                !!(
                                    !this.props.data.function ||
                                    (this.props.context && startsWith(this.props.data.function, MODELS.ORGANIZATION))
                                )
                            }
                            items={this.props.groupsForSelect}
                            label="Group *"
                            onChange={this._inputEventReset}
                            name="group"
                            value={this.props.data.group}
                        />
                    </div>
                    <div className="ckp-admin-grid-column">
                        <SelectField
                            disabled={!this.props.data.function}
                            items={this.props.rolesForSelect}
                            label="Permission *"
                            onChange={this._rolesSelect}
                            name="name"
                            value={this.props.data.name}
                        />
                    </div>
                </div>
                <div className="ckp-admin-grid-row">
                    {this.props.showOrganizations ? (
                        <div className="ckp-admin-grid-column">
                            <SelectField
                                disabled={!!this.props.context}
                                items={this.props.organizationsForSelect}
                                label="Organization *"
                                onChange={this._inputEventReset}
                                name="orgId"
                                value={this.props.data.orgId}
                            />
                        </div>
                    ) : null}
                    <div className="ckp-admin-grid-column">
                        <SelectField
                            disabled={this.props.disableEventSelection}
                            items={this.props.eventsForSelect}
                            label="Event *"
                            onChange={this.props.onInput}
                            name="eventId"
                            value={this.props.data.eventId}
                        />
                    </div>
                </div>
                {this.props.hasRoleSelected && (
                    <React.Fragment>
                        <div className="ckp-admin-grid-row">
                            <FormControlLabel
                                className="ckp-checkbox-mui"
                                control={
                                    <Checkbox
                                        name="accessToClearanceContracts"
                                        checked={
                                            this.props.data.accessToClearanceContracts || this.props.isOrganizationUser
                                        }
                                        disabled={this.props.isArtistUser || this.props.isOrganizationUser}
                                        onChange={e => this._inputCheckbox(e.target.checked, e.target.name)}
                                    />
                                }
                                label="Access to clearance contracts *"
                            />
                        </div>
                        <div className="ckp-admin-grid-row">
                            <FormControlLabel
                                className="ckp-checkbox-mui"
                                control={
                                    <Checkbox
                                        name="accessToPerformanceContracts"
                                        checked={this.props.data.accessToPerformanceContracts}
                                        disabled={!this._canChangePerformanceAccess()}
                                        onChange={e => this._inputCheckbox(e.target.checked, e.target.name)}
                                    />
                                }
                                label="Access to performance contracts *"
                            />
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, props) => ({
    user: currentUserSelector(state),
    functionsForSelect: selectors.functionsSelector(state, props),
    groupsForSelect: selectors.groupOptionsSelector(state, props),
    rolesForSelect: selectors.rolesOptionsSelector(state, props),
    isArtistUser: selectors.isArtistUserSelector(state, props),
    isOrganizationUser: selectors.isOrganizationUserSelector(state, props),
    hasRoleSelected: selectors.hasRoleSelectedSelector(state, props),
    organizationsForSelect: selectors.organizationsOptionsSelector(state, props),
    showOrganizations: selectors.showOrganizationsSelector(state, props),
    eventsForSelect: selectors.eventsOptionsSelector(state, props),
    disableEventSelection: selectors.eventDisabledSelector(state, props)
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PermissionInputs);



// WEBPACK FOOTER //
// ./src/containers/admin/contacts/PermissionInputs.js